module.exports = "/images/layer.svg?0a348639534a323f3741431db18cb2a5";